// Minimal preset list to speed up creating/editing countries from known values
export const COUNTRY_PRESETS = [
  { name: 'Kuwait', code: 'KW', phoneCode: '+965', phoneLength: 8, currency: 'KWD', currencySymbol: 'KD' },
  { name: 'United States', code: 'US', phoneCode: '+1', phoneLength: 10, currency: 'USD', currencySymbol: '$' },
  { name: 'United Kingdom', code: 'GB', phoneCode: '+44', phoneLength: 10, currency: 'GBP', currencySymbol: '£' },
  { name: 'Saudi Arabia', code: 'SA', phoneCode: '+966', phoneLength: 9, currency: 'SAR', currencySymbol: '﷼' },
  { name: 'United Arab Emirates', code: 'AE', phoneCode: '+971', phoneLength: 9, currency: 'AED', currencySymbol: 'د.إ' },
];

export function applyCountryPreset(preset, mutate) {
  if (!preset || typeof mutate !== 'function') return;
  mutate({
    name: preset.name,
    code: preset.code,
    phoneCode: preset.phoneCode,
    phoneLength: String(preset.phoneLength),
    currency: preset.currency,
    currencySymbol: preset.currencySymbol,
  });
}


